import { render, staticRenderFns } from "./BorrarPatrocinador.vue?vue&type=template&id=7e3e330c"
import script from "./BorrarPatrocinador.vue?vue&type=script&lang=js"
export * from "./BorrarPatrocinador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports